import React from 'react';
import '../App.css';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery
  ///input
} from '@material-ui/core';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { mainBlueColor, isUserId } from '../GlobalState';
import { currencyStyle } from '../utils/common';

type GraphStatus = {
  assignee_user: string;
  target_sales: number;
  actual_sales: number;
  target_gross_profit: number;
  actual_gross_profit: number;
  goal_achievement_rate: number;
  assignee_user_id: any;
  in_progress_target: number;
  in_progress_performance: number;
  in_progress_achievement_rate: number;
  construction_target: number;
  construction_performance: number;
  construction_achievement_rate: number;
  completion_target: number;
  completion_performance: number;
  completion_achievement_rate: number;
};

type GraphStatuses = {
  currency: number;
  graphStatus: GraphStatus[];
};

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

function createData(
  assignee_user: string,
  target_sales: number,
  actual_sales: number,
  target_gross_profit: number,
  actual_gross_profit: number,
  goal_achievement_rate: any,
  assignee_user_id: any,
  in_progress_target: number,
  in_progress_performance: number,
  in_progress_achievement_rate: number,
  construction_target: number,
  construction_performance: number,
  construction_achievement_rate: number,
  completion_target: number,
  completion_performance: number,
  completion_achievement_rate: number
) {
  return {
    assignee_user,
    target_sales,
    actual_sales,
    target_gross_profit,
    actual_gross_profit,
    goal_achievement_rate,
    assignee_user_id,
    in_progress_target,
    in_progress_performance,
    in_progress_achievement_rate,
    construction_target,
    construction_performance,
    construction_achievement_rate,
    completion_target,
    completion_performance,
    completion_achievement_rate
  };
}

const PersonalTable: React.FC<GraphStatuses> = graphStatuses => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const setUserId = useSetRecoilState(isUserId);
  const rows = graphStatuses.graphStatus.map((output, index) => {
    return createData(
      output.assignee_user,
      output.target_sales,
      output.actual_sales,
      output.target_gross_profit,
      output.actual_gross_profit,
      output.goal_achievement_rate,
      output.assignee_user_id,
      output.in_progress_target,
      output.in_progress_performance,
      output.in_progress_achievement_rate,
      output.construction_target,
      output.construction_performance,
      output.construction_achievement_rate,
      output.completion_target,
      output.completion_performance,
      output.completion_achievement_rate
    );
  });

  const useStyles = makeStyles({
    mainClass: {
      maxHeight: 390
    },
    main: {
      minWidth: 700
      //minWidth: 550,
    },
    table: {
      backgroundColor: mainColor,
      color: '#FFFFFF',
      fontSize: 12
    },
    table1: {
      backgroundColor: '#f5f5f5',
      color: '#000000',
      fontSize: 12
    }
  });
  // const handleClickFun = (e: any, id: any) => {
  //   //setUserId(id)
  //   if (e.target.checked) {
  //     setUserId(id)

  //     setActive(e.target.checked)
  //     //console.log("rowstrue", e, id)
  //   } else {
  //     setUserId("0")
  //     setActive(e.target.checked)
  //     //console.log("rowsfalse", e, id)

  //   }

  //   //setActive(e.target.checked)
  // }
  const handleClickRow = (clickedRowId: any) => {
    setUserId(clickedRowId);
  };

  const classes = useStyles();
  const matches2 = useMediaQuery('(min-width:900px)');

  return (
    <div
      className={
        matches2
          ? 'responsive-container-bottom-left'
          : 'responsive-container-bottom-left2'
      }
    >
      <TableContainer className={classes.mainClass} component={Paper}>
        <Table className={classes.main} aria-label='customized table'>
          <TableHead>
            <TableRow>
              {/* <StyledTableCell className={classes.table} align="center">
                名前
                      className={classes.table}
                      align="center"
              </StyledTableCell> */}
              <StyledTableCell
                style={{
                  minWidth: 80,
                  position: 'sticky',
                  left: 0,
                  zIndex: 1
                }}
                className={classes.table}
                align='center'
              >
                名前
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                売上目標
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                売上実績
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                粗利目標
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                粗利実績
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                粗利目標達成率
              </StyledTableCell>

              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                営業中(ランクA)案件目標
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                営業中(ランクA)案件実績
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                営業中(ランクA)案件目標達成率
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                工事案件目標
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                工事案件実績
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                工事案件目標達成率
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                完了案件目標
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                完了案件実績
              </StyledTableCell>
              <StyledTableCell
                style={{ minWidth: 80 }}
                className={classes.table}
                align='center'
              >
                完了案件目標達成率
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <StyledTableRow
                key={row.assignee_user}
                className='click_table_row'
                title='各行をクリックすると、個々の工事の結果が表示されます。'
                onClick={(e: any) => {
                  handleClickRow(row.assignee_user_id);
                }}
              >
                {/* <StyledTableCell className={classes.table1} align="center">
                  <input
                    type="checkbox"
                    checked={active[index]}
                    onClick={(e: any) => { handleClickFun(e, row.assignee_user_id); }}
                  />
                </StyledTableCell> */}
                <StyledTableCell
                  style={{
                    minWidth: 80,
                    position: 'sticky',
                    left: 0,
                    zIndex: 1
                  }}
                  className={classes.table1}
                  align='center'
                >
                  {row.assignee_user}
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='right'>
                  {currencyStyle(row.target_sales, graphStatuses.currency)}
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='right'>
                  {currencyStyle(row.actual_sales, graphStatuses.currency)}
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='right'>
                  {currencyStyle(
                    row.target_gross_profit,
                    graphStatuses.currency
                  )}
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='right'>
                  {currencyStyle(
                    row.actual_gross_profit,
                    graphStatuses.currency
                  )}
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='right'>
                  {isNaN(row.goal_achievement_rate) ||
                  !row.goal_achievement_rate
                    ? 0
                    : row.goal_achievement_rate}{' '}
                  %
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {/* {currencyStyle(row.in_progress_target, graphStatuses.currency)} */}
                  {row.in_progress_target} 件
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {/* {currencyStyle(row.in_progress_performance, graphStatuses.currency)} */}
                  {row.in_progress_performance} 件
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {isNaN(row.in_progress_achievement_rate) ||
                  !row.in_progress_achievement_rate
                    ? 0
                    : row.in_progress_achievement_rate}{' '}
                  %
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {/* {currencyStyle(row.construction_target, graphStatuses.currency)} */}
                  {row.construction_target} 件
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {/* {currencyStyle(row.construction_performance, graphStatuses.currency)} */}
                  {row.construction_performance} 件
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {isNaN(row.construction_achievement_rate) ||
                  !row.construction_achievement_rate
                    ? 0
                    : row.construction_achievement_rate}{' '}
                  %
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {/*  {currencyStyle(row.completion_target, graphStatuses.currency)} */}
                  {row.completion_target} 件
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {/* {currencyStyle(row.completion_performance, graphStatuses.currency)} */}
                  {row.completion_performance} 件
                </StyledTableCell>
                <StyledTableCell className={classes.table1} align='center'>
                  {isNaN(row.completion_achievement_rate) ||
                  !row.completion_achievement_rate
                    ? 0
                    : row.completion_achievement_rate}{' '}
                  %
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
export default PersonalTable;
